import { Space, Title, Descriptions, Text } from '@bancobarigui/barihaus';
import { formatarMoeda, formatarArea } from '../utils';

interface TerrenoSectionProps {
  areaTerreno: number;
  valorUnitarioTerreno: number;
  valorParcialTerreno: number;
}

export function TerrenoSection({
  areaTerreno,
  valorUnitarioTerreno,
  valorParcialTerreno,
}: TerrenoSectionProps) {
  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Title level={4}>Terreno</Title>
      <Descriptions
        bordered
        size="small"
        column={1}
        items={[
          {
            key: '1',
            label: 'Área (m²)',
            children: `${formatarArea(areaTerreno)} m²`,
          },
          {
            key: '2',
            label: 'Valor unitário (R$/m²)',
            children: formatarMoeda(valorUnitarioTerreno),
          },
          {
            key: '3',
            label: 'Valor parcial (R$)',
            children: (
              <Text style={{ fontWeight: 600, color: '#1890ff' }}>
                {formatarMoeda(valorParcialTerreno)}
              </Text>
            ),
          },
        ]}
      />
    </Space>
  );
}
